<template>
  <section>
    <el-row class="warp">
      <el-col :span="6" class="warp-breadcrum">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/resultMng/journalDataAudit' }">
              <b>卷期列表</b>
            </el-breadcrumb-item>
            <el-breadcrumb-item>文章详情列表</el-breadcrumb-item>
          </el-breadcrumb>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" size="small" @click="back(null)">返回</el-button>
      </el-col>
    </el-row>  
    <el-row class="warp">
      <el-descriptions class="margin-top" :column="3" border>
          <el-descriptions-item label="期刊名称">
              <template slot="label"><i class="el-icon-tickets"></i>期刊名称</template>
              {{this.searchForm.journalName}}
          </el-descriptions-item>
          <el-descriptions-item label="年">
              <template slot="label"><i class="el-icon-tickets"></i>年份</template>
              {{this.searchForm.year}}
          </el-descriptions-item>
      </el-descriptions>
    </el-row>
      <!--工具条 begin-->
    <el-row class="warp">
      <!-- 列表显示 begin-->
      <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
        <el-table :data="issueInfoList" style="width: 100%;overflow: auto;" stripe border highlight-current-row v-loading="pageLoading" element-loading-text="反馈中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <!-- 第一行显示数据 -->
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column prop="id" label="Id" sortable align="center"></el-table-column>
          <el-table-column prop="dataName" label="文章名称" sortable align="center"></el-table-column>
          <el-table-column prop="uploadTime" label="上传时间" sortable align="center"></el-table-column>
          <el-table-column prop="transStatus" label="转换状态" sortable align="center">
              <template slot-scope="scope">
                <el-tag
                    :type="scope.row.transStatus === 1 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.transInfo}}
                </el-tag>
              </template>
          </el-table-column>
          <el-table-column prop="pubStatus" label="发布状态" sortable align="center">
            <template slot-scope="scope">
                <el-tag
                    :type="scope.row.pubStatus === 1 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.pubInfo}}
                </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="审核状态" sortable align="center">
            <template slot-scope="scope">
                <el-tag
                    :type="scope.row.auditStatus === 1 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.auditInfo}}
                </el-tag>
            </template>
          </el-table-column>
          <!-- 上传按钮 -->
          <!--
              pubStatus: 0-失败 1-成功
              auditStatus: 0-待审核 1-通过 2-不通过
              -->
          <el-table-column label="审核" width="240" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" :style="(scope.row.pubStatus === 1 && scope.row.auditStatus !==2) ? { display: '' } : { display: 'none' }" @click="skip(scope.$index, scope.row)">跳转</el-button>
              <el-button type="danger" size="mini" :style="(scope.row.auditStatus === 2) ? { display: '' } : { display: 'none' }" @click="showReason(scope.row)">反馈</el-button>
            </template>
          </el-table-column>
          <!-- 操作按钮 -->
          <el-table-column label="操作" width="240" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" :style="(scope.row.pubStatus === 1 && scope.row.auditStatus === 0) ? { display: '' } : { display: 'none' }" @click="passAudit(scope.row)">通过</el-button>
              <el-button type="primary" size="mini" :style="(scope.row.pubStatus === 1 && scope.row.auditStatus === 0) ? { display: '' } : { display: 'none' }" @click="rejectAudit(scope.row)">不通过</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 列表显示 end-->

      <!--新增对话框界面 begin-->
    <el-dialog title="问题反馈" :visible.sync="addFormVisible" :close-on-click-modal="false" v-loading="rejectLoading" element-loading-text="反馈中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <!-- 创建form -->
        <el-form-item label="请填写审核不通过的原因：" prop="reason">
          <el-input type="textarea" :rows="5" v-model="addForm.reason" placeholder="请在此输入审核不通过的原因"></el-input>
        </el-form-item>
      </el-form>
      <!-- 创建form -->
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
    <!-- 新增对话框界面 end -->
    </el-row>
  </section>
</template>

<script>
import API_JOURNALDATA from "../../../api/api_journalData";
export default {
    data() {
        return {
            searchForm:{
                journalName:"",
                year:"",
                journalId:"",
                issue:"",
                insId:"",
                audit:'',
            },
            issueInfoList: [],
            //页面载入状态
            rejectLoading: false,
            pageLoading:false,
            fileList: [],
            //在此添加新的数据定义

            addFormVisible: false, //新增界面是否显示
            addLoading: false, //新增界面加载状态
            addFormRules: {
                reason: [{ required: true, message: "请输入审核不通过的原因", trigger: "blur" }], 
            },
            addForm: {
                id:"",
                reason: "",
            },
        };
    },
    created(){
        this.dataInit();
        this.getIssueInfoList();
    },
    mounted() {
        
    },

    methods: {
        dataInit(){
            let that = this;
            that.searchForm.journalName = this.$route.query.journalName;
            that.searchForm.year = this.$route.query.year;
            that.searchForm.journalId = this.$route.query.journalId;
            that.searchForm.issue = this.$route.query.issue;
            that.searchForm.insId = this.$route.query.insId;
            that.searchForm.audit = this.$route.query.audit;
        },

        getIssueInfoList(){
            let that = this;
            let params = {
                yearValue: that.searchForm.year,
                journalId: that.searchForm.journalId,
                issue: that.searchForm.issue
            };
            console.log("......getIssueInfoList params:" + JSON.stringify(params));
            //发送http请求
            API_JOURNALDATA.getIssueInfoList(params)
            .then(res => {
                if(res && res.issueInfoList){
                    that.issueInfoList = Object.values(res.issueInfoList);
                    console.log(
                        "......getIssueInfoList:" + JSON.stringify(that.issueInfoList)
                    );
                }
            })
            .catch(e => {
                this.$message({
                    showClose: true,
                    type: "error",
                    message: "请求出现异常",
                    duration: 2000
                });
            });
        },

        back(){
          this.$router.push({path: '/resultMng/journalDataAudit', query: {yearValue: this.searchForm.year, journalId: this.searchForm.journalId, insId: this.searchForm.insId}})
        },

        skip: function(index, row) {
          console.log("........skip:" + JSON.stringify(row));
          let href = row.pubUrl;
          console.log("........skip:" + href);
          window.open(href, '_blank');
        },

        passAudit(row){
            let params = {
                id: row.id,
            };
            console.log("......passAudit params:" + JSON.stringify(params));

            this.pageLoading = true;

            //发送http请求
            API_JOURNALDATA.passAudit(params)
            .then(res => {
                if(res && res.errorCode === 0){
                   //刷新列表
                   this.getIssueInfoList();
                }
                this.pageLoading = false;
            })
            .catch(e => {
                this.$message({
                    showClose: true,
                    type: "error",
                    message: "通过请求出现异常",
                    duration: 2000
                });
                this.pageLoading = false;
            });
        },

        rejectAudit(row){
            let that = this;
            that.addForm.id = row.id;
            that.addFormVisible = true;
        },

        //新增提交
        addSubmit: function() {
            let that = this;
            if (that.formLoading) return;
            that.$refs.addForm.validate(valid => {
                if (valid) {
                let params = {
                    id: that.addForm.id,
                    reason: that.addForm.reason,
                };

                that.rejectLoading = true;

                console.log(
                    ".........reason create by params:" + JSON.stringify(params)
                );

                //发送http请求
                API_JOURNALDATA.rejectAudit(params)
                    .then(res => {
                    if (0 === res.errorCode) {
                        that.$message({
                        type: "success",
                        message: "反馈成功!"
                        });

                        //创建成功后，刷新列表显示
                        this.getIssueInfoList();
                        that.$refs["addForm"].resetFields(); //清空数据
                        that.addFormVisible = false;
                    } else {
                        that.$message({
                        showClose: true,
                        message: res.errorInfo,
                        type: "error"
                        });
                    }
                    that.rejectLoading = false;
                    })
                    .catch(e => {
                    that.$message({
                        showClose: true,
                        type: "error",
                        message: "请求出现异常",
                        duration: 2000
                    });
                    that.rejectLoading = false;
                    });
                } else {
                that.$message({
                    showClose: true,
                    type: "error",
                    message: "请正确填写信息！",
                    duration: 2000
                });
                }
            });
        },

        showReason(row){
            this.$alert(
            row.auditRejectInfo, 
            '问题反馈', 
            {
                confirmButtonText: '确定',
            });
        }
    }
}
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Data/AuditManageInfo.vue